// extracted by mini-css-extract-plugin
export var statItem = "_ch-1";
export var statsRow = "_ch-0";